/**
 * Global context for shopping cart
 * To access global context: 
 * const { addToCart, incrementQuantity, decrementQuantity, totalItem, totalQty, cartItems, calculateGrandTotal, removeFromCart, emptyCart } = useShoppingCart();
 */
import React, { createContext, useState, useContext, useEffect } from 'react';

const ShoppingCartContext = createContext();

export function ShoppingCartProvider({ children }) {
  const [cartItems, setCartItems] = useState(() => {
    const storedCartItems = localStorage.getItem('cartItems');
    return storedCartItems ? JSON.parse(storedCartItems) : [];
  });

  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (item) => {
    removeFromCart(item.id);
    setCartItems((prevCartItems) => [
      ...prevCartItems, item
    ]);
  };

  const removeFromCart = (itemId) => {
    const itemIndex = cartItems.findIndex((item) => item.id === itemId);

    if (itemIndex !== -1) {
      const newCartItems = [...cartItems];
      newCartItems.splice(itemIndex, 1);
      setCartItems(newCartItems);
    }
  };

  /**
   * Update cart item value
   * @param string name - name of attribute e.g: quanity, logo
   * @param int productId - 
   * @param any value 
   */
  const updateCartItem = (itemId, name, value) => {
    setCartItems((prevCartItems) =>
      prevCartItems.map((item) =>
        item.id === itemId ? { ...item, [name]: value } : item
      )
    );
  };

  const calculateGrandTotal = () => {
    return cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  const totalQty = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };

  const totalItem = (itemId) => {
    const item = cartItems.find((item) => item.id === itemId);
    return item ? item.quantity : 0;
  };

  const emptyCart = () => {
    setCartItems([]);
  };

  return (
    <ShoppingCartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateCartItem,
        totalQty,
        totalItem,
        calculateGrandTotal,
        emptyCart
      }}
    >
      {children}
    </ShoppingCartContext.Provider>
  );
}

export function useShoppingCart() {
  return useContext(ShoppingCartContext);
}
